import React, { useState } from 'react';
import { MapPin, ArrowUpRight, FileText } from 'lucide-react';
import PropertyDetailModal from './PropertyDetailModal';

export default function PropertyCard({ property, index = 0 }) {
  const [open, setOpen] = useState(false);
  return (
    <>
    <div
      className="property-card glass copper-border rounded-3xl overflow-hidden animate-float-in"
      style={{ animationDelay: `${0.2 + index * 0.12}s` }}
      data-testid={`property-card-${property.id}`}
    >
      {/* Image */}
      <div className="relative h-56 overflow-hidden cursor-pointer" onClick={() => setOpen(true)}>
        <img
          src={property.image}
          alt={property.title}
          className="w-full h-full object-cover"
          style={{ filter: 'saturate(1.1) contrast(1.05)' }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1C130D] via-transparent to-transparent" />

        {/* Top labels */}
        <div className="absolute top-4 left-4 flex gap-2">
          <span className="capsule capsule-copper backdrop-blur-md">{property.type}</span>
        </div>
        <div className="absolute top-4 right-4">
          <span className="capsule glass text-[#F4ECDF] backdrop-blur-md">{property.code}</span>
        </div>

        {/* Price overlay */}
        <div className="absolute bottom-4 left-4">
          <div className="font-display text-2xl copper-shine font-medium tracking-tight">
            {property.price}
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="p-6">
        <div className="flex items-start justify-between gap-3 mb-2">
          <h3 className="font-display text-lg text-[#F4ECDF] font-medium leading-tight cursor-pointer hover:text-[#F7D002] transition-colors"
            onClick={() => setOpen(true)}
          >
            {property.title}
          </h3>
          <button
            onClick={() => setOpen(true)}
            className="text-[#E08A4F] hover:text-[#F7D002] transition-colors flex-shrink-0"
            data-testid={`property-quick-${property.id}`}
            aria-label="Detayı aç"
          >
            <ArrowUpRight size={18} />
          </button>
        </div>

        <div className="flex items-center gap-1.5 text-[#F4ECDF]/50 text-xs mb-5 font-body">
          <MapPin size={11} />
          <span className="tracking-wider uppercase">{property.location}</span>
        </div>

        {/* AI 3 highlights */}
        <div className="space-y-2.5">
          <div className="font-body text-[9px] tracking-[0.3em] text-[#E08A4F]/60 uppercase mb-2 flex items-center gap-2">
            <div className="w-1 h-1 rounded-full bg-[#68E5B2] animate-pulse" />
            AI Tarafından Saptanan Öne Çıkanlar
          </div>
          <div className="flex flex-wrap gap-2">
            {property.highlights.map((h, i) => (
              <span
                key={i}
                className={`capsule ${i === 0 ? 'capsule-mint' : i === 1 ? 'capsule-yellow' : 'capsule-copper'}`}
              >
                {h}
              </span>
            ))}
          </div>
        </div>

        {/* Stats footer */}
        <div className="grid grid-cols-3 gap-3 mt-5 pt-5 border-t border-white/5">
          <div>
            <div className="font-body text-[9px] text-white/40 tracking-wider uppercase">m²</div>
            <div className="font-display text-base text-[#F4ECDF] font-medium mt-0.5">{property.size}</div>
          </div>
          <div>
            <div className="font-body text-[9px] text-white/40 tracking-wider uppercase">Oda</div>
            <div className="font-display text-base text-[#F4ECDF] font-medium mt-0.5">{property.rooms}</div>
          </div>
          <div>
            <div className="font-body text-[9px] text-white/40 tracking-wider uppercase">Skor</div>
            <div className="font-display text-base text-[#68E5B2] font-medium mt-0.5">{property.aiScore}</div>
          </div>
        </div>

        {/* Detaylar button */}
        <button
          onClick={() => setOpen(true)}
          className="mt-5 w-full flex items-center justify-center gap-2 px-4 py-3 rounded-full transition-all hover:scale-[1.01] active:scale-[0.99]"
          style={{
            background: 'linear-gradient(135deg, #E08A4F 0%, #C56C39 50%, #8E4A23 100%)',
            border: '1px solid rgba(244,213,184,0.4)',
            boxShadow: '0 1px 0 rgba(244,213,184,0.45) inset, 0 6px 16px -6px rgba(197,108,57,0.55)',
            color: '#1C130D',
          }}
          data-testid={`property-detail-btn-${property.id}`}
        >
          <FileText size={13} />
          <span className="font-display text-[11px] tracking-[0.22em] uppercase font-semibold">
            Detaylar
          </span>
        </button>
      </div>
    </div>
    {open && <PropertyDetailModal property={property} onClose={() => setOpen(false)} />}
    </>
  );
}
